import styles from './style.module.scss';
import React from 'react';

const AccountSkeleton: React.FC = () => {
    return (
        <div className={styles.container}>
            <section className={styles.section}>
                <h3>Account Information</h3>
                <div className={styles.row}>
                    <div className={styles.column}>
                        {/* <div className={styles.label}>Title:</div> */}
                        <div className={styles.skeletonBox}></div>
                        {/* <div className={styles.label}>First name:</div> */}
                        <div className={styles.skeletonBox}></div>
                        {/* <div className={styles.label}>Phone number:</div> */}
                        {/* <div className={styles.skeletonBox}></div> */}
                    </div>
                    <div className={styles.column}>
                        {/* <div className={styles.label}>Last name:</div> */}
                        <div className={styles.skeletonBox}></div>
                        {/* <div className={styles.label}>Email:</div> */}
                        <div className={styles.skeletonBox}></div>
                    </div>
                </div>
            </section>

            <section className={styles.section}>
                <h3>Company name:</h3>
                <div className={styles.logoSkeleton}></div>
                {/* <div className={styles.label}>Company website:</div> */}
                <div className={styles.skeletonBox}></div>
                <div className={styles.addressRow}>
                    <div className={styles.skeletonSmall}></div>
                    <div className={styles.skeletonSmall}></div>
                    <div className={styles.skeletonSmall}></div>
                    <div className={styles.skeletonSmall}></div>
                </div>
            </section>

            <section className={styles.section}>
                <h3>Account Seats</h3>
                <div className={styles.skeletonBox}></div>
            </section>

            <section className={styles.section}>
                <h3>Plan Information</h3>
                {/* <div className={styles.tabRow}>
                    <div className={`${styles.tab} ${styles.active}`}>Current plan</div>
                    <div className={styles.tab}>Plan’s history</div>
                </div> */}
                <div className={styles.skeletonBox}></div>
            </section>
        </div>
    );
};

export default AccountSkeleton;
